import React from 'react'

import { styled } from '@thg-commerce/gravity-theme'

import { SSMProductInfo } from './ShoeSizeMeLoaderScript'

const ProductBlockText = styled.div`
  margin-top: 0 !important;

  .ssm_coll {
    left: -22px;
    top: -16px;
  }
`

export const ShoeSizeMeProductBlock = ({
  sku,
  sizes,
  inStockSizes,
}: SSMProductInfo) => {
  const sortAndFilterSizeArray = (sizeArray) => {
    if (sizeArray) {
      return sizeArray.filter((item) => !isNaN(item)).sort((a, b) => a - b)
    }
    return
  }

  return (
    <ProductBlockText
      className="ShoeSizeMe ssm_plp"
      data-shoeid={sku}
      data-sizerun={sortAndFilterSizeArray(sizes)}
      data-availability={sortAndFilterSizeArray(inStockSizes)}
    />
  )
}
